import { useParams, Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-background-100 rounded-full">
            <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-2">分类未找到</h1>
          <p className="text-sm text-foreground-500 mb-6">该分类不存在或已被移除</p>
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-home-line"></i> 返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-background-50">
      <div className="w-full px-4 md:px-6 pt-24 pb-14">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: category.name },
            ]}
          />

          {/* Category Header */}
          <div className="mb-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
                <i className={`${category.icon} text-lg text-accent-600`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {category.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-500 ml-13">{category.description}</p>
          </div>

          {/* Category Tabs */}
          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                }`}
              >
                <i className={`${cat.icon} text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Articles Grid */}
          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-background-100 rounded-full">
                <i className="ri-inbox-line text-3xl text-foreground-400"></i>
              </div>
              <p className="text-sm text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}